var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "import-reports-show-view"
  }, [(_vm.isLoading) ? _c('loader') : [_c('h1', [_vm._v(_vm._s(_vm.importerName))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.information')))]), _vm._v(" "), _c('attribute-table', {
    attrs: {
      "data": _vm.importReport,
      "fields": ['status', 'scope', 'startedAt', 'updatedAt', 'finishedAt', 'timingInfo', 'details']
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(statusProps) {
        return [_c('import-status', {
          attrs: {
            "errors": statusProps.row.errorsCount,
            "value": statusProps.value
          }
        }), _vm._v(" "), (statusProps.value == 'RUNNING') ? _c('confirmation-button', {
          attrs: {
            "text": "Cancel"
          },
          on: {
            "confirm": function($event) {
              _vm.cancelImport()
            }
          }
        }) : _vm._e()]
      }
    }, {
      key: "scope",
      fn: function(scopeProps) {
        return [(scopeProps.value) ? _c('span', [_vm._v("\n          " + _vm._s(scopeProps.value) + "\n        ")]) : _c('text-placeholder')]
      }
    }, {
      key: "startedAt",
      fn: function(startedAtProps) {
        return [(startedAtProps.value) ? _c('span', [_vm._v("\n         " + _vm._s(_vm._f("niceTime")(startedAtProps.value)) + "\n       ")]) : _c('text-placeholder')]
      }
    }, {
      key: "updatedAt",
      fn: function(updatedAtProps) {
        return [(updatedAtProps.value) ? _c('span', [_vm._v("\n         " + _vm._s(_vm._f("niceTime")(updatedAtProps.value)) + "\n       ")]) : _c('text-placeholder')]
      }
    }, {
      key: "finishedAt",
      fn: function(finishedAtProps) {
        return [(finishedAtProps.value) ? _c('span', [_vm._v("\n         " + _vm._s(_vm._f("niceTime")(finishedAtProps.value)) + "\n       ")]) : _c('text-placeholder')]
      }
    }, {
      key: "timingInfo",
      fn: function(timingInfoProps) {
        return [(_vm.importReport.timingInfo) ? _c('ul', _vm._l((_vm.importReport.timingInfo), function(timingInfo) {
          return _c('li', [_vm._v(_vm._s(timingInfo))])
        })) : _c('text-placeholder')]
      }
    }, {
      key: "details",
      fn: function(detailsProps) {
        return [_c('table', [_c('tr', [_c('th', [_vm._v("Schlüssel")]), _vm._v(" "), _c('th', [_vm._v("Wert")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.importReport.details), function(detail) {
          return _c('import-report-detail', {
            key: detail.key,
            attrs: {
              "keyPair": detail.key,
              "valuePair": detail.value
            }
          })
        })], 2)]
      }
    }])
  }), _vm._v(" "), (_vm.importReport.error) ? [_c('h3', [_vm._v(_vm._s(_vm.$t('headlines.errors')))]), _vm._v(" "), (_vm.viewedError) ? _c('modal', {
    ref: "errorModal",
    staticClass: "uk-modal-container",
    attrs: {
      "title": _vm.$t('headlines.error'),
      "auto-overflow": ""
    },
    on: {
      "hidden": _vm.onErrorModalHidden
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.viewedError.message))]), _vm._v(" "), (_vm.viewedError.details.length) ? _c('dl', [_vm._l((_vm.viewedError.details), function(errorDetail) {
    return [_c('dt', [_vm._v(_vm._s(errorDetail.key))]), _vm._v(" "), _c('dd', [_c('pre', [_vm._v(_vm._s(errorDetail.value))])])]
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-divider uk-table-justify"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fehlerart")]), _vm._v(" "), _c('th', [_vm._v("Import-Schritt")]), _vm._v(" "), _c('th', [_vm._v("Artikelnummer")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.message')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.occurredAt')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.importReport.errors.entries), function(error) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(error.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(error.step))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/products?search=' + error.article_number
      }
    }, [_vm._v("\n                " + _vm._s(error.article_number) + "\n              ")])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showError(error)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("truncate")(error.message, 80)))])]), _vm._v(" "), _c('td', [_c('timeago', {
      attrs: {
        "auto-update": 60,
        "since": error.occurredAt
      }
    })], 1)])
  }))]), _vm._v(" "), _c('paginator', {
    attrs: {
      "page-info": _vm.importReport.errors.pagination
    }
  })] : _vm._e()]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-023b8346","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ImportReports/ShowView.vue
// module id = 1832
// module chunks = 0